import getCookie from "./getCookie";
import deleteCookie from "./deleteCookie";
import isArray from "./isArray";

const setGAEvent = (event, params1, params2) => {
  let data;
  const affiliation = getCookie("affiliateType");

  if (
    event === "add_to_cart" ||
    event === "view_item" ||
    event === "remove_from_cart" ||
    event === "click_PDP_collection_name"
  ) {
    const { code, productName1, usage, categories, productName2 } = params1;
    const { origPrice, discountPrice, quantity } = params2;
    const price = origPrice
      ? Number(origPrice.replace(/^HK\$/, "").replace(/,/g, ""))
      : 0;
    const discount =
      origPrice && discountPrice
        ? Number(origPrice.replace(/^HK\$/, "").replace(/,/g, "")) -
          Number(discountPrice.replace(/^HK\$/, "").replace(/,/g, ""))
        : 0;
    const _dataLayers = isArray(window.dataLayer) ? window.dataLayer : [];
    const _view_item = _dataLayers.find(data => data.event === "view_item") || {
      ecommerce: {}
    };
    const item_list_name =
      getCookie("ga4_item_list_name") ||
      _view_item.ecommerce.item_list_name ||
      undefined;
    const item_list_id =
      getCookie("ga4_item_list_id") ||
      _view_item.ecommerce.item_list_id ||
      undefined;
    const codeLength = code.length;
    const firstDashIndex = code.indexOf("-");
    const secondDashIndex = code.indexOf("-", firstDashIndex + 1);
    const item_category2 = code.substring(firstDashIndex + 1, secondDashIndex);
    const item_category3 = code.substring(secondDashIndex + 1, codeLength);
    const item_category4 = "定價";
    const _items = [
      {
        item_id: code,
        price: Number(price),
        discount: Number(discount),
        item_brand: productName1 || "",
        item_category: usage.code || "",
        item_category2: item_category2 || "",
        item_category3: item_category3 || "",
        item_category4: item_category4,
        item_list_name: item_list_name,
        item_list_id: item_list_id,
        quantity: 1
      }
    ];
    data = {
      event: event,
      ecommerce: {
        item_list_id: item_list_id,
        item_list_name: item_list_name,
        currency: "HKD",
        value: price,
        items: _items
      }
    };
    if (affiliation) {
      data.ecommerce.affiliation = affiliation;
    }
    if (event === "click_PDP_collection_name") {
      data.ecommerce.items[0].item_name = productName2;
    }
  } else if (
    event === "view_cart" ||
    event === "begin_checkout" ||
    event === "add_shipping_info" ||
    event === "add_payment_info" ||
    event === "purchase"
  ) {
    const { totalNetAmount, cartItems, coupons } = params1;
    const value = totalNetAmount
      ? Number(totalNetAmount.replace(/^HK\$/, "").replace(/,/g, ""))
      : 0;
    const item_list_name = getCookie("ga4_item_list_name") || undefined;
    const item_list_id = getCookie("ga4_item_list_id") || undefined;
    const _items = isArray(cartItems)
      ? cartItems.map((data, index) => {
          const { information, discountAmount, quantity } = data;
          const { prodname1, prodname2, code, origPrice } = information;
          const price = origPrice
            ? Number(origPrice.replace(/^HK\$/, "").replace(/,/g, ""))
            : 0;
          const discount = discountAmount
            ? price -
              Number(discountAmount.replace(/^HK\$/, "").replace(/,/g, ""))
            : 0;

          const codeLength = code.length;
          const firstDashIndex = code.indexOf("-");
          const secondDashIndex = code.indexOf("-", firstDashIndex + 1);
          const usage = code.substring(firstDashIndex - 1, firstDashIndex);
          const item_category2 = code.substring(
            firstDashIndex + 1,
            secondDashIndex
          );
          const item_category3 = code.substring(
            secondDashIndex + 1,
            codeLength
          );
          const item_category4 = "定價";
          return {
            item_id: code,
            price: Number(price),
            discount: Number(discount),
            item_brand: prodname1,
            quantity: Number(quantity),
            item_category: usage,
            item_category2: item_category2,
            item_category3: item_category3,
            item_category4: item_category4,
            item_list_name: item_list_name,
            item_list_id: item_list_id
          };
        })
      : [];
    data = {
      event: event,
      ecommerce: {
        currency: "HKD",
        value: value,
        items: _items
      }
    };
    if (isArray(coupons)) {
      const _coupons = coupons.map(item => item.couponCode);
      data.ecommerce.coupon = _coupons.join(",");
    }
    if (affiliation) {
      data.ecommerce.affiliation = affiliation;
    }
    if (event === "add_shipping_info") {
      const shippingTier = params2 ? "In-Store" : "Delivery";
      data.ecommerce.shipping_tier = shippingTier;
    }
    if (event === "add_payment_info") {
      data.ecommerce.payment_type = params2.paymentType;
      const shippingTier = params2.shippingTier ? "In-Store" : "Delivery";
      data.ecommerce.shipping_tier = shippingTier;
    }
  } else {
    return;
  }
  if (window.dataLayer && data) {
    window.dataLayer.push(data);
    deleteCookie("ga4_item_list_name");
    deleteCookie("ga4_item_list_id");
  }
};

export { setGAEvent };
